import { useEffect } from "react";
import { useRouter } from "expo-router";
import { View } from "react-native";

const SpotOnRoute = () => {
  const router = useRouter();

  // redirect to integrations page with spoton modal open
  useEffect(() => {
    setTimeout(() => {
      router.replace({
        pathname: "/integrations",
        params: { openModal: "spoton" },
      });
    }, 100);
  }, [router]);

  return <View className="flex-1" />;
};

export default SpotOnRoute;
